module.exports = __webpack_public_path__ + "static/media/oneday_9.c2367284.png";